import { Component, OnInit, inject, input } from '@angular/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';

import { LoadingService } from '@app/services/loading.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { tap } from 'rxjs';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
    imports: [ProgressSpinnerModule],
})
export class LoadingOverlayComponent implements OnInit {
    readonly detectRouteTransitions = input(false);

    loadingService = inject(LoadingService);
    router = inject(Router);

    ngOnInit(): void {
        if (this.detectRouteTransitions()) {
            this.router.events
                .pipe(
                    tap((event) => {
                        if (event instanceof RouteConfigLoadStart) {
                            this.loadingService.show();
                        } else if (
                            event instanceof RouteConfigLoadEnd ||
                            event instanceof NavigationEnd
                        ) {
                            setTimeout(() => this.loadingService.hide(), 500);
                        }
                    }),
                )
                .subscribe();
        }
    }
}
